import { formatMXN } from "@/lib/catalog";

const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

// "2026-11-15" -> "15 de noviembre de 2026" (sin desfase de zona horaria)
export function formatYMD(ymd) {
  if (!ymd) return null;
  const [y, m, d] = ymd.split("-").map(Number);
  return `${d} de ${MESES[m - 1]} de ${y}`;
}

export function vigenciaText(o) {
  const a = formatYMD(o?.vigencia_inicio);
  const b = formatYMD(o?.vigencia_fin);
  if (a && b) return `Vigente del ${a} al ${b}`;
  if (b) return `Vigente hasta el ${b}`;
  if (a) return `Vigente desde el ${a}`;
  return null;
}

export const OFERTA_ESTADO = {
  vigente: { label: "Vigente", cls: "bg-green-50 text-green-800 border-green-200" },
  programada: { label: "Programada", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  inactiva: { label: "Inactiva", cls: "bg-[#F1F3F3] text-[#6B7678] border-[#3E5641]/15" },
  vencida: { label: "Vencida", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const money = (v) => (v === null || v === undefined || v === "" ? null : formatMXN(v));
